const apiUrl = process.env.REACT_APP_API_URL;

export interface GeneratedAvatarResult {
    skinId: number | null;
    skinNom: string | null;
    avatarId: number | null;
    avatarNom: string | null;
}

/**
 * Crida l'objecte "Generar Avatar": el backend tria aleatòriament una skin i un avatar
 * elegibles (recompenses d'activitats finalitzades que l'usuari encara no té), els
 * desbloqueja, consumeix l'objecte i retorna el que s'ha generat.
 * Retorna null si no hi havia res elegible o si hi ha hagut un error.
 */
export const PostGenerateRandomAvatar = async (
    userId: string,
    objectId: number
): Promise<GeneratedAvatarResult | null> => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/shop/generate-random-avatar`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userId, objectId }),
        });

        if (response.ok) {
            return (await response.json()) as GeneratedAvatarResult;
        }
        return null;
    } catch (error) {
        console.error('Error generating random avatar:', error);
        return null;
    }
};
